/* eslint-disable import/prefer-default-export */
import { useContext, useEffect } from "react";
import addNotification from "react-push-notification";
import { useQuery, useQueryClient } from "react-query";
import { SocketContext } from "../services/socket";

import { getMessages } from "../api/ProgramMessages";

const key = "program-messages";
const MESSAGE_SONG_URL =
  "https://public-resourses-files.s3.us-east-2.amazonaws.com/AUDIO/message.mp3";

export function useProgramMessages(page) {
  return useQuery([key, page], () => getMessages(page), {
    refetchOnWindowFocus: false,
  });
}

const notificationPush = () => {
  addNotification({
    title: "Corporación de ayuda",
    message: "Tiene un nuevo mensaje, verifique el detalle en sistema.",
    duration: 15000,
    native: true,
  });
  document.title = "Nueva notificación";
};

export function useInvalidateProgramMessages({
  user,
  setPage,
  setHasNewMessages,
  programId,
}) {
  const audio = new Audio(MESSAGE_SONG_URL);
  const socket = useContext(SocketContext);
  const queryClient = useQueryClient();

  useEffect(() => {
    socket.on("REFRESH_MESSAGES", (data) => {
      if (
        user?._id !== data?.userId &&
        (data?.toRoles?.includes(user?.role) ||
          data?.toUserIds?.includes(user?._id))
      ) {
        setPage(0);
        queryClient.invalidateQueries([key]);
        if (programId !== data?.programId) {
          audio.play();
          setHasNewMessages(true);
          notificationPush();
        }
      }
    });
    return () => {
      socket.off("REFRESH_MESSAGES");
    };
  }, [socket]);
}
